const AVATAR_COLORS = [
  "var(--color-primary)",
  "var(--color-primary-light)",
  "var(--color-success)",
  "var(--color-warning)",
  "var(--color-danger)",
  "var(--color-text-primary)",
  "var(--color-text-muted)",
];

export function getAvatarColor(id) {
  if (id === 0) return "var(--color-primary)";
  if (id === -1) return "var(--color-text-muted)";
  return AVATAR_COLORS[id % AVATAR_COLORS.length];
}

export function getDeadlineParts(dateStr) {
  const raw = typeof dateStr === "string" ? dateStr.trim() : "";
  if (!raw) return { date: "", time: "", raw: "" };

  const direct = new Date(raw);
  if (!Number.isNaN(direct.getTime())) {
    const year = direct.getFullYear();
    const month = String(direct.getMonth() + 1).padStart(2, "0");
    const day = String(direct.getDate()).padStart(2, "0");
    const hours = String(direct.getHours()).padStart(2, "0");
    const minutes = String(direct.getMinutes()).padStart(2, "0");

    return {
      date: `${year}-${month}-${day}`,
      time: `${hours}:${minutes}`,
      raw,
    };
  }

  const datePart = raw.match(/^(\d{4}-\d{2}-\d{2})/)?.[1] || "";
  const timePart = raw.match(/T(\d{2}:\d{2})/)?.[1] || "";

  return {
    date: datePart,
    time: timePart,
    raw,
  };
}

export function formatDate(dateStr) {
  if (!dateStr) return "Bez daty";
  const raw = String(dateStr).trim();
  const datePart = raw.match(/^(\d{4}-\d{2}-\d{2})/)?.[1];
  if (!datePart) return "Bez daty";

  const d = new Date(`${datePart}T12:00:00`);
  if (Number.isNaN(d.getTime())) return "Bez daty";

  return d.toLocaleDateString("pl-PL", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
}

export function groupByDate(tasks) {
  const withDate = tasks
    .filter((t) => t.date)
    .sort((a, b) => {
      const da = a.date + (a.time || "00:00");
      const db = b.date + (b.time || "00:00");
      return da.localeCompare(db);
    });

  const withoutDate = tasks.filter((t) => !t.date);
  const groups = {};

  withDate.forEach((t) => {
    if (!groups[t.date]) groups[t.date] = [];
    groups[t.date].push(t);
  });

  return { groups, dateKeys: Object.keys(groups).sort(), withoutDate };
}

function pluralize(value, one, few, many) {
  if (value === 1) return one;
  const mod10 = value % 10;
  const mod100 = value % 100;
  if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) {
    return few;
  }
  return many;
}

function formatApproximateCountdown(diffMs) {
  const totalMinutes = Math.max(1, Math.floor(Math.abs(diffMs) / 60000));
  const dayMinutes = 24 * 60;

  if (totalMinutes >= dayMinutes) {
    const days = Math.floor(totalMinutes / dayMinutes);
    return `${days} ${pluralize(days, "dzień", "dni", "dni")}`;
  }

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const parts = [];

  if (hours > 0) {
    parts.push(`${hours} ${pluralize(hours, "godzina", "godziny", "godzin")}`);
  }
  if (minutes > 0 || parts.length === 0) {
    parts.push(`${minutes} ${pluralize(minutes, "minuta", "minuty", "minut")}`);
  }

  return parts.join(" ");
}

export function getDeadlineCountdown(dateStr, timeStr) {
  if (!dateStr) return "Bez terminu";

  const raw = String(dateStr).trim();
  const direct = new Date(raw);
  if (!Number.isNaN(direct.getTime()) && /T/.test(raw)) {
    const diffDirect = direct.getTime() - Date.now();
    const amountDirect = formatApproximateCountdown(diffDirect);
    return diffDirect >= 0 ? `Za ${amountDirect}` : `Po terminie o ${amountDirect}`;
  }

  const { date: datePart, time: parsedTime } = getDeadlineParts(raw);
  const finalTime = timeStr || parsedTime || "23:59";

  if (!datePart) return "Bez terminu";

  const deadline = new Date(`${datePart}T${finalTime}:00`);
  if (Number.isNaN(deadline.getTime())) return "Bez terminu";

  const diffMs = deadline.getTime() - Date.now();
  const amountText = formatApproximateCountdown(diffMs);
  return diffMs >= 0 ? `Za ${amountText}` : `Po terminie o ${amountText}`;
}
